const DEFAULT_OFFSET_IN_PX = 150;

export function scrollToTarget(target, {offset = DEFAULT_OFFSET_IN_PX} = {}) {
    const coords = {
        x: 0,
        y: target.offset().top - offset + window.scrollY,
    };

    try {
        window.scrollTo({
            behavior: 'smooth',
            left: coords.x,
            top: coords.y,
        });
    } catch (err) {
        window.scrollTo(coords.x, coords.y);
    }
}
